import axios from 'axios';
import { API_ROOT } from './apiConfig';
import Auth from '../services/auth';
const endpoint = `${API_ROOT}/api/v1/Coding`;

export const cancelPhysicianQuery = async (cancelRequest) => {
    const auth = new Auth();
    return await axios.post(`${endpoint}/physicianquery/cancel`, cancelRequest,
        {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${auth.getToken()}`
            }
        }
    )
}


// WEBPACK FOOTER //
// ./src/services/codingService.js